<div class="prompt-container">
  <mat-form-field class="textarea-container">
    <mat-label class="smaller-label">{{ label }}</mat-label>
    <textarea
      matInput
      cdkTextareaAutosize
      #autosize="cdkTextareaAutosize"
      [(ngModel)]="prompt"
      (ngModelChange)="onPromptChange()"
      [disabled]="disabled"
      (keydown.enter)="sendMessage()"
      [cdkTextareaAutosize]="true"
      [cdkAutosizeMinRows]="2"
      [cdkAutosizeMaxRows]="10"
      data-test-id="advisor-textarea">
    </textarea>
    <button
      mat-icon-button
      matSuffix
      (click)="sendMessage()"
      [disabled]="disabled"
      class="send-button"
      matTooltip="Send Prompt"
      data-test-id="send-button">
      <mat-icon class="material-symbols-outlined">send</mat-icon>
    </button>
  </mat-form-field>
</div>
